import HttpClienteToken from '../../services/HttpClientToken';

import { AxiosError } from 'axios';

import { HttpResponse } from '../../interfaces/auth/AuthInterface';

import { BuscarDocumentoParams, BuscarDocumentoResponse, CancelarDocumentoParams } from '../../interfaces/admin/AdministracionDocumentosInterface';

export const BuscarDocumento = ( params: BuscarDocumentoParams ) => {

    return new Promise<BuscarDocumentoResponse>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/AdministrarDocumento/BuscarDocumento', params, token)
            .then( ({ data } : { data : BuscarDocumentoResponse } ) => {               
                resolve( data );                
            })
            .catch( ( error: AxiosError ) => {
                resolve({
                    success: false,
                    message: error.message,
                    id: '', 
                    folio: '', 
                    numeroSeguimiento: '', 
                    urlDescarga: '',
                    idEstatus: 0,
                    estatus: '',
                    bitacoraDocumentos: [],
                });
            });
        }

    });

}

export const CancelarDocumento = ( params: CancelarDocumentoParams ) => {

    return new Promise<HttpResponse>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/AdministrarDocumento/CancelarDocumento', params, token)
            .then( ({ data } : { data : HttpResponse } ) => {               
                resolve( data );                
            })
            .catch( ( error: AxiosError ) => {
                resolve({
                    success: false,
                    message: error.message,
                });
            });
        }

    });

}